import React from "react"
import { withRouter, Link } from "react-router-dom"
import { Card, Container, Grid, Button } from "semantic-ui-react"
import "../Overview.css"
import { PlanCard } from "./PlanCard"

export const PlanSelector = withRouter(
  ({ history, selectPlan, inviteUrl, plans, showAlternatives = true }) => {
    if (plans.length > 0) {
      return (
        <Container textAlign="center" className="white">
          <Grid className="overview_maindiv">
            <Grid.Row style={{ paddingBottom: "0px" }}>
              <Grid.Column textAlign="center">
                <h2 className="overview__Heading">Choose a Plan</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered style={{ paddingTop: "0px" }}>
              <Grid.Column
                className="overview__Description"
                width={14}
                textAlign="center"
              >
                <p className="overview__DescriptionText">
                  Take control of your financial future today!
                </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column>
                <Card.Group className="PlanChooser__CardGroup">
                  {plans.map(plan => (
                    <PlanCard
                      key={plan.id}
                      planId={plan.id}
                      features={plan.features}
                      name={plan.name}
                      onSelect={() => selectPlan(plan)}
                      isFeatured={plan.is_featured}
                      description={plan.description}
                      nonfeatures={plan.non_features}
                      interval={plan.interval}
                      amount={plan.amount}
                      free_trial_days={plan.free_trial_days}
                    />
                  ))}
                </Card.Group>
              </Grid.Column>
            </Grid.Row>
            {showAlternatives ? (
              <Grid.Row centered>
                <Grid.Column width={12} textAlign="center">
                  <Link to="/signup/invited" data-testid="invited">
                    Have an invite code?
                  </Link>
                </Grid.Column>
                <Grid.Column width={12} textAlign="center">
                  <Link to="/signup/employer" data-testid="employer">
                    Signing up through your employer?
                  </Link>
                </Grid.Column>
              </Grid.Row>
            ) : null}
          </Grid>
        </Container>
      )
    } else {
      return (
        <Container textAlign="center" className="white">
          <Grid className="overview_maindiv">
            <Grid.Row style={{ paddingBottom: "0px" }}>
              <Grid.Column textAlign="center">
                <h2 className="overview__Heading">No Plans Available</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered style={{ paddingTop: "0px" }}>
              <Grid.Column
                className="overview__Description"
                width={14}
                textAlign="center"
              >
                <p className="overview__DescriptionText">
                  We're sorry, but we are not currently accepting direct
                  sign-ups.
                </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column width={12} textAlign="center">
                <Link to={inviteUrl}>
                  <Button content="Use Invite Code" basic type="button" />
                </Link>
                <Button
                  content="Notify Me"
                  primary
                  href="https://savvifi.us17.list-manage.com/subscribe?u=959133753b2ef2809f40d4f21&id=47cf6e5786"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      )
    }
  }
)
